import React from 'react';
import DriversList from '../../Components/SupervisorsItems/DriversList/DriversList';
import { hasPermission } from '../../Services/permission';

const DRIVER_SECTION = "drivers";
const DRIVER_EDIT_KEY = ["drivers_edit"];

const Drivers = () => {
    const canEditDriver = hasPermission({ section: DRIVER_SECTION, keys: DRIVER_EDIT_KEY });

    return (
        <DriversList canEditDriver={canEditDriver} />
    );
};

export default Drivers;
